import _ from 'lodash';
import { sqWorkbenchStore } from '@/core/core.stores';
import { isTrustedUser } from '@/services/authorization.service';
import { errorToast } from '@/utilities/toast.utilities';
import { sqSystemApi } from '@seeqdev/api/endpoint/SystemApi';
import type { AddOnToolOutputV1 } from '@seeqdev/api/model/AddOnToolOutputV1';

/**
 * Load the add-on tools that are relevant to the current user, across all launch locations.
 */
export function loadAddOnTools(): Promise<AddOnToolOutputV1[]> {
  if (!isTrustedUser()) {
    return Promise.resolve([]);
  }

  return sqSystemApi
    .getAddOnTools()
    .then(({ data: { addOnTools } }) => {
      const myUserId = sqWorkbenchStore.currentUser.id;
      // We don't want admins to see all addOns on the system, just relevant ones
      return _.filter(addOnTools, (addOnTool) => {
        return !addOnTool.inDevelopment || addOnTool?.installer?.id === myUserId;
      });
    })
    .catch((error) => {
      errorToast({ httpResponseOrError: error });
      return [];
    });
}
